import React from 'react';
import './Button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'answer' | 'choice';
  selected?: boolean;
  children: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'default', selected = false, className = '', children, ...props }, ref) => {
    const baseClasses = 'button touchable transition-interactive';

    const variantClasses = {
      default: '',
      answer: 'button--answer',
      choice: 'button--choice',
    };

    const selectedClass = selected ? 'button--selected' : '';

    const classes = [
      baseClasses,
      variantClasses[variant],
      selectedClass,
      className,
    ].filter(Boolean).join(' ');

    return (
      <button ref={ref} className={classes} {...props}>
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';